import request from "./client";

export type TenantUser = {
  id: number;
  tenantId: number;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  role: "tenant";
};

export type TenantLoginResponse = {
  token: string;
  user: TenantUser;
};

export type TenantProfile = {
  user: TenantUser & {
    phone: string | null;
    dateOfBirth: string | null;
    nationalInsuranceNumber: string | null;
    emergencyContactName: string | null;
    emergencyContactPhone: string | null;
  };
  tenancy: {
    tenancy_id: number;
    tenancy_start: string;
    tenancy_end: string | null;
    payment_date: string | null;
    monthly_rent: number;
    deposit_amount: number;
    status: string;
    room_number: string;
    floor_number: number | null;
    property_name: string;
    address_line_1: string;
    city: string;
    postcode: string;
  } | null;
};

export async function loginTenant(email: string, password: string) {
  return request<TenantLoginResponse>("/api/tenant/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export async function getTenantProfile(token: string) {
  return request<TenantProfile>("/api/tenant/profile", {
    headers: { Authorization: `Bearer ${token}` },
  });
}
